"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("./Text"));
var _Button = _interopRequireDefault(require("./Button"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _i18n = _interopRequireDefault(require("../localization/i18n"));
var _tokens = _interopRequireDefault(require("../localization/tokens"));
var _ = require("..");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * 
 * @param {*} props 
 * @returns 
 */
var MetaBlock = function MetaBlock(props) {
  var showModal = props.showModal,
    data = props.data,
    disabled = props.disabled;
  var asoDetails = _i18n["default"].t(_tokens["default"].labels.quotes.none);
  if (data.meta.aso && data.meta.aso.isASO) {
    if (data.meta.aso.isAsoDental && data.meta.aso.isAsoHealth) {
      asoDetails = _i18n["default"].t(_tokens["default"].labels.quotes.healthAndDental);
    } else if (data.meta.aso.isAsoDental) {
      asoDetails = _i18n["default"].t(_tokens["default"].labels.quotes.dentalOnly);
    } else if (data.meta.aso.isAsoHealth) {
      asoDetails = _i18n["default"].t(_tokens["default"].labels.healthOnly);
    }
    if (data.meta.aso.asoType === 'Arrears') {
      asoDetails = "".concat(asoDetails, " ").concat(_i18n["default"].t(_tokens["default"].labels.quotes.inArrears));
    } else {
      asoDetails = "".concat(asoDetails, " ").concat(_i18n["default"].t(_tokens["default"].labels.quotes.budgeted));
    }
  }
  var styles = {
    container: {
      display: 'flex',
      flex: 1,
      boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
      padding: "10px 32px",
      zIndex: 2,
      height: 150,
      flexWrap: 'wrap',
      background: '#FFF'
    },
    main: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    },
    row: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      padding: "10px 0"
    },
    block: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.main
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.block
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true,
    small: true
  }, _i18n["default"].t(_tokens["default"].labels.account.companyName)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    tiny: true
  }, data.meta.company)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.block
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true,
    small: true
  }, _i18n["default"].t(_tokens["default"].labels.account.companyEmail)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    tiny: true
  }, data.meta.email)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.block
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true,
    small: true
  }, _i18n["default"].t(_tokens["default"].labels.phoneNumber)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    tiny: true
  }, data.meta.phone)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.block
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true,
    small: true
  }, _i18n["default"].t(_tokens["default"].labels.account.signingAuthorityName)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    tiny: true
  }, data.meta.authority.name))), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.block
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true,
    small: true
  }, _i18n["default"].t(_tokens["default"].labels.account.lastUpdated)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    tiny: true
  }, dates.getLocalDisplay(data.meta.dateUpdated, 'MMMM DD, YYYY'))), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.block
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true,
    small: true
  }, _i18n["default"].t(_tokens["default"].labels.masterApplication.companyAddress)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    tiny: true
  }, "".concat(data.meta.address.split(',')[0], ", ").concat(data.meta.address.split(',')[1], ", ").concat(_.localizationMaps.fromEnglish("provinces", data.meta.address.split(',')[2])))), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.block
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true,
    small: true
  }, _i18n["default"].t(_tokens["default"].labels.account.asoDetails)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    tiny: true
  }, asoDetails)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.block
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    bold: true,
    small: true
  }, _i18n["default"].t(_tokens["default"].labels.account.signingAuthorityEmail)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    tiny: true
  }, data.meta.authority.email)))), !disabled && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: showModal,
    color: "primary",
    customStyle: {
      height: 25,
      textTransform: 'capitalize'
    }
  }, _i18n["default"].t(_tokens["default"].buttons.edit)));
};
var _default = exports["default"] = MetaBlock;